<template>
  <div class="ls-numbered-list">
    <div
      v-for="(item, idx) in items"
      :key="item"
      class="wrapper"
      :class="{ 'top-border': idx > 0 }"
    >
      <div class="icon-wrapper">
        <div class="number-icon">{{ idx + 1 }}</div>
      </div>

      <p class="item-text">{{ item }}</p>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'LsNumberedList',
  props: {
    items: VueTypes.arrayOf(VueTypes.string).isRequired,
  },
};
</script>

<style lang="scss" scoped>
.ls-numbered-list {
  .wrapper {
    display: flex;
    align-items: flex-start;
    .icon-wrapper {
      flex-shrink: 0;
      display: flex;
      align-items: flex-end;
      padding-top: 20px;
    }
  }

  .number-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background-color: $primary-light;
    color: $primary;
    font-size: $size-5;
    font-weight: 700;
  }
  .item-text {
    padding: 25px 0 25px 20px;
  }
  .top-border {
    border-top: 1px solid $primary-light;
  }
}

@media (max-width: $mobile-max-width) {
  .ls-numbered-list {
    .wrapper {
      flex-direction: column;
      align-items: center;
    }
    .item-text {
      padding: 15px 0;
    }
  }
}

.themed-app {
  .ls-numbered-list {
    .number-icon {
      background-color: $theme-color-primary-light;
      color: $theme-color-primary;
      font-size: var(--theme-txt-body);
    }
  }
  .top-border {
    border-top: 1px solid $theme-color-primary-light;
  }
}
</style>
